import { GetterTree } from 'vuex';
import { BankDataState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<BankDataState, RootState> = {
  ['getBankDataIsLoading']: (state) => state.isLoading,
  ['getBankDataPaymentMandate']: (state) => state.paymentMandate,
  ['getBankDataPaymentMandateHistory']: (state) => state.paymentMandateHistory,
};
